import { render, staticRenderFns } from "./ReportMissedCalls.vue?vue&type=template&id=1e20e52d"
import script from "./ReportMissedCalls.vue?vue&type=script&lang=js"
export * from "./ReportMissedCalls.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports